import PropTypes from "prop-types";
import styled from "styled-components";
import { COLOR_VALUES } from "shared/config/colors";
import Icon, { ICON_NAMES } from "shared/components/utils/Icon";
import Text from "shared/components/data-display/text/Text";
import BaseButton from "shared/components/inputs/button/BaseButton";
import Tooltip from "shared/components/utils/tooltip/Tooltip";
import { TertiaryButtonStyle } from "shared/components/inputs/button/Button.styles";

const StyledTertiaryButton = styled(BaseButton)`
    color: ${COLOR_VALUES.Black} !important; /* !important to override css reboot */
    text-decoration: none !important; /* !important to override css reboot */
    padding: ${({ $reducePadding }) =>
        $reducePadding ? "4px 4px" : "4px 8px"};
    min-height: 24px;

    ${TertiaryButtonStyle}
`;

const TertiaryButton = ({
    label,
    leadingIcon,
    trailingIcon,
    tooltip,
    disabled = false,
    iconWidth = 16,
    ...rest
}) => {
    const ariaLabel = rest["aria-label"];

    if (!label && !ariaLabel) {
        console.error("Icon-only button missing aria-label");
    }

    return (
        <Tooltip text={ariaLabel} enabled={!label}>
            <StyledTertiaryButton
                    $reducePadding={!label}
                    disabled={disabled}
		            tooltip={tooltip}                    
		            {...rest}
                >
                    {leadingIcon && (
                        <Icon name={leadingIcon} width={iconWidth} />
                    )}
                    {label && <Text variant="Body_2_2">{label}</Text>}
                    {trailingIcon && (
                        <Icon name={trailingIcon} width={iconWidth} />
                    )}
                </StyledTertiaryButton>
        </Tooltip>
    );
};

TertiaryButton.propTypes = {
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
    ]),
    leadingIcon: PropTypes.oneOf(ICON_NAMES),
    trailingIcon: PropTypes.oneOf(ICON_NAMES),
    "aria-label": PropTypes.string,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    iconWidth: PropTypes.number,
};

export default TertiaryButton;
